export default __webpack_public_path__ + "24.03.2017_Pressemitteilung_Kooperation_HPI_LifeTime1c48bc521142c5456d2d6e42b18b0e9a.pdf";